import { Doctor } from '@nrwl/rx-models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@nrwl/environment';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  constructor(private _http: HttpClient) {}

  public getDoctors(): Observable<any> {
    return this._http
      .get(environment.baseAPIUrlv3 + 'doctor/?limit=3000&expand=locations&omit=clinic')
      .pipe(
        tap((response) => console.log('getDoctors response:', response)),
        map((res: any) => res.results.map((item) => new Doctor(item))),
      );
  }

  public getDoctor(id): Observable<any> {
    console.log('getDoctor', id);
    return this._http.get(environment.baseAPIUrlv3 + 'doctor/' + id + '/?expand=locations').pipe(
      tap((response) => console.log(`getDoctor(${id}) response:`, response)),
      map((res: any) => new Doctor(res)),
    );
  }

  public getArchiveDoctors(): Observable<any> {
    return this._http.get(environment.baseAPIUrlv3 + 'doctor/?archived=true&expand=locations').pipe(
      tap((response) => console.log('getArchiveDoctors response:', response)),
      map((res: any) => res.map((item) => new Doctor(item))),
    );
  }

  public updateDoctor(data: any): Observable<any> {
    if (data.locations) {
      data = {
        ...data,
        locations: data.locations.map((loc) => loc.id || loc),
      };
    } else if (!data?.locations[0].id) {
      delete data.locations;
    }
    const url = `${environment.baseAPIUrlv3}doctor/${data.id}/`;

    return this._http.patch(url, data).pipe(
      tap((response) => console.log(`updateDoctor(${data.id}) response:`, response)),
      map((res: any) => new Doctor(res)),
    );
  }

  public createDoctor(data: Doctor): Observable<any> {
    return this._http.post(environment.baseAPIUrlv3 + 'doctor/', data).pipe(
      tap((response) => console.log('createDoctor response:', response)),
      map((res: any) => new Doctor(res)),
    );
  }

  public postDoctorTypes(id: number, payload: number[]): Observable<any> {
    return this._http
      .post(`${environment.baseAPIUrl}doctor/${id}/doctor_type/`, { doctor_type: payload })
      .pipe(tap((response) => console.log(`postDoctorTypes(${id}) response:`, response)));
  }

  public checkEmail(email: string): Observable<any> {
    return this._http
      .post(environment.baseAPIUrlv3 + 'check-email/', {
        email,
      })
      .pipe(tap((response) => console.log(`checkEmail(${email}) response:`, response)));
  }

  public checkUsername(username: string): Observable<any> {
    return this._http
      .post(environment.baseAPIUrlv3 + 'check-username/', {
        username,
      })
      .pipe(tap((response) => console.log(`checkUsername(${username}) response:`, response)));
  }

  public resetPassword(data: Doctor): Observable<any> {
    return this._http
      .post(environment.baseAPIUrlv3 + 'doctor/' + data.id + '/reset-password/', data)
      .pipe(tap((response) => console.log(`resetPassword(${data.id}) response:`, response)));
  }

  public archiveDoctor(data: Doctor): Observable<any> {
    return this._http
      .delete(environment.baseAPIUrlv3 + 'doctor/' + data.id + '/')
      .pipe(tap((response) => console.log(`archiveDoctor(${data.id}) response:`, response)));
  }

  public setAvatar(file, data): Observable<any> {
    return this._http
      .post(environment.baseAPIUrlv3 + 'doctor/' + data.id + '/set-photo/', file)
      .pipe(tap((response) => console.log(`setAvatar(${data.id}) response:`, response)));
  }

  public clearAvatar(data): Observable<any> {
    return this._http
      .post(environment.baseAPIUrlv3 + 'doctor/' + data.id + '/clear-photo/', null)
      .pipe(tap((response) => console.log(`clearAvatar(${data.id}) response:`, response)));
  }

  public updateLocations(data: Doctor, locationList: number[]): Observable<any> {
    const url = `${environment.baseAPIUrlv3}doctor/${data.id}/locations/`;

    return this._http
      .put(url, {
        locations: locationList,
        is_active: data.is_active,
      })
      .pipe(tap((response) => console.log(`updateLocations(${data.id}) response:`, response)));
  }
}
